var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn btn-primary full-width",attrs:{"disabled":_vm.disabled,"type":"submit"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }